import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Row } from 'reactstrap'
import FormItem from '../../components/form/FormItem'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { GiVerticalBanner } from "react-icons/gi";
import { FcDown } from 'react-icons/fc'
import { BiDownArrow } from 'react-icons/bi'
import { PiTextT } from 'react-icons/pi'
import { fetchContentUpdate } from '../../redux/slices/contentUpdateSlice'
import { fetchContentGet } from '../../redux/slices/contentGetSlice'

const CrudContent = () => {
    const [formData, setFormData] = useState({ files: [] })
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const getData = async () => {
        var data = await dispatch(fetchContentGet())
        if (data.payload) {
            setFormData({
                files: data.payload?.files,
                footerTexttr: data.payload?.footerText["tr"],
                footerTexten: data.payload?.footerText["en"],
                footerText2tr: data.payload?.footerText2["tr"],
                footerText2en: data.payload?.footerText2["en"],
                bannerTexttr: data.payload?.bannerText["tr"],
                bannerTexten: data.payload?.bannerText["en"],
                bannerText2tr: data.payload?.bannerText2["tr"],
                bannerText2en: data.payload?.bannerText2["en"],
                bannerText3tr: data.payload?.bannerText3["tr"],
                bannerText3en: data.payload?.bannerText3["en"],
                showcaseTexttr: data.payload?.showcaseText["tr"],
                showcaseTexten: data.payload?.showcaseText["en"],
                showcaseText2tr: data.payload?.showcaseText2["tr"],
                showcaseText2en: data.payload?.showcaseText2["en"],
                showcaseText3tr: data.payload?.showcaseText3["tr"],
                showcaseText3en: data.payload?.showcaseText3["en"],
                specialField1tr: data.payload?.specialField1["tr"],
                specialField1en: data.payload?.specialField1["en"],
                specialField2tr: data.payload?.specialField2["tr"],
                specialField2en: data.payload?.specialField2["en"],
                specialField3tr: data.payload?.specialField3["tr"],
                specialField3en: data.payload?.specialField3["en"],
                specialField4tr: data.payload?.specialField4["tr"],
                specialField4en: data.payload?.specialField4["en"],
                specialField5tr: data.payload?.specialField5["tr"],
                specialField5en: data.payload?.specialField5["en"],
                specialField6tr: data.payload?.specialField6["tr"],
                specialField6en: data.payload?.specialField6["en"],
            })
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const footerText = { "tr": formData.footerTexttr, "en": formData.footerTexten }
        const footerText2 = { "tr": formData.footerText2tr, "en": formData.footerText2en }
        const bannerText = { "tr": formData.bannerTexttr, "en": formData.bannerTexten }
        const bannerText2 = { "tr": formData.bannerText2tr, "en": formData.bannerText2en }
        const bannerText3 = { "tr": formData.bannerText3tr, "en": formData.bannerText3en }
        const showcaseText = { "tr": formData.showcaseTexttr, "en": formData.showcaseTexten }
        const showcaseText2 = { "tr": formData.showcaseText2tr, "en": formData.showcaseText2en }
        const showcaseText3 = { "tr": formData.showcaseText3tr, "en": formData.showcaseText3en }
        const specialField1 = { "tr": formData.specialField1tr, "en": formData.specialField1en }
        const specialField2 = { "tr": formData.specialField2tr, "en": formData.specialField2en }
        const specialField3 = { "tr": formData.specialField3tr, "en": formData.specialField3en }
        const specialField4 = { "tr": formData.specialField4tr, "en": formData.specialField4en }
        const specialField5 = { "tr": formData.specialField5tr, "en": formData.specialField5en }
        const specialField6 = { "tr": formData.specialField6tr, "en": formData.specialField6en }

        await dispatch(
            fetchContentUpdate({
                file: formData.files,
                footerText: footerText,
                footerText2: footerText2,
                bannerText: bannerText,
                bannerText2: bannerText2,
                bannerText3: bannerText3,
                showcaseText: showcaseText,
                showcaseText2: showcaseText2,
                showcaseText3: showcaseText3,
                specialField1: specialField1,
                specialField2: specialField2,
                specialField3: specialField3,
                specialField4: specialField4,
                specialField5: specialField5,
                specialField6: specialField6
            })
        )

        getData()
    }

    useEffect(() => { getData() }, [dispatch])

    return (
        <Form onSubmit={handleSubmit} className='mt-4 mb-4'>
            <Row>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`footerTexttr`}
                        name={`footerTexttr`}
                        type="text"
                        icon={<FcDown size={20} className='color4' />}
                        title={`${t("footer_text1")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='footerTexttr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`footerTexten`}
                        name={`footerTexten`}
                        type="text"
                        icon={<FcDown size={20} className='color4' />}
                        title={`${t("footer_text1")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='footerTexten'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`footerText2tr`}
                        name={`footerText2tr`}
                        type="text"
                        icon={<BiDownArrow size={20} className='color4' />}
                        title={`${t("footer_text2")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='footerText2tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`footerText2en`}
                        name={`footerText2en`}
                        type="text"
                        icon={<BiDownArrow size={20} className='color4' />}
                        title={`${t("footer_text2")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='footerText2en'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`bannerTexttr`}
                        name={`bannerTexttr`}
                        type="text"
                        icon={<GiVerticalBanner size={20} className='color4' />}
                        title={`${t("product_families_banner_text")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='bannerTexttr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`bannerTexten`}
                        name={`bannerTexten`}
                        type="text"
                        icon={<GiVerticalBanner size={20} className='color4' />}
                        title={`${t("product_families_banner_text")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='bannerTexten'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`bannerText2tr`}
                        name={`bannerText2tr`}
                        type="text"
                        icon={<GiVerticalBanner size={20} className='color4' />}
                        title={`${t("about_banner_text")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='bannerText2tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`bannerText2en`}
                        name={`bannerText2en`}
                        type="text"
                        icon={<GiVerticalBanner size={20} className='color4' />}
                        title={`${t("about_banner_text")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='bannerText2en'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`bannerText3tr`}
                        name={`bannerText3tr`}
                        type="text"
                        icon={<GiVerticalBanner size={20} className='color4' />}
                        title={`${t("news_banner_text")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='bannerText3tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`bannerText3en`}
                        name={`bannerText3en`}
                        type="text"
                        icon={<GiVerticalBanner size={20} className='color4' />}
                        title={`${t("news_banner_text")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='bannerText3en'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`showcaseTexttr`}
                        name={`showcaseTexttr`}
                        type="text"
                        icon={<GiVerticalBanner size={20} className='color4' />}
                        title={`${t("contact_banner_text")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='showcaseTexttr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`showcaseTexten`}
                        name={`showcaseTexten`}
                        type="text"
                        icon={<GiVerticalBanner size={20} className='color4' />}
                        title={`${t("contact_banner_text")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='showcaseTexten'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`showcaseText2tr`}
                        name={`showcaseText2tr`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("product_families_title")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='showcaseText2tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`showcaseText2en`}
                        name={`showcaseText2en`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("product_families_title")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='showcaseText2en'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`showcaseText3tr`}
                        name={`showcaseText3tr`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("product_families_desc")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='showcaseText3tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`showcaseText3en`}
                        name={`showcaseText3en`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("product_families_desc")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='showcaseText3en'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`specialField1tr`}
                        name={`specialField1tr`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("product_f_url")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField1tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`specialField1en`}
                        name={`specialField1en`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("product_f_url")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField1en'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`specialField2tr`}
                        name={`specialField2tr`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("all_news_text")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField2tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`specialField2en`}
                        name={`specialField2en`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("all_news_text")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField2en'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`specialField3tr`}
                        name={`specialField3tr`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("linkedin_title_text")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField3tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`specialField3en`}
                        name={`specialField3en`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("linkedin_title_text")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField3en'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`specialField4tr`}
                        name={`specialField4tr`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("homepage_product_title")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField4tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`specialField4en`}
                        name={`specialField4en`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("homepage_product_title")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField4en'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`specialField5tr`}
                        name={`specialField5tr`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("preview_text")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField5tr'
                    />
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                    <FormItem
                        id={`specialField4en`}
                        name={`specialField4en`}
                        type="text"
                        icon={<PiTextT size={20} className='color4' />}
                        title={`${t("preview_text")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField5en'
                    />
                </Col>
            </Row>
            <div className='d-flex justify-content-end mt-4 w-100'>
                <Button type='submit' color='warning' className="text-white">
                    {t("edit")}
                </Button>
            </div>
        </Form>
    )
}

export default CrudContent
